export const SUPPORTED_LANGUAGES: Record<string,string> = {
    pl: 'pl-PL',
    en: 'en-GB',
};